import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { uploadFiles } from "../../utils/uploadFiles";
import endPoints from "../../shared/services/endPoints";
import api from "../../shared/services/api";
import { showToast } from "./toastSlice";
import { hideLoader, showLoader } from "./loaderSlice";

export const submitEnquiry = createAsyncThunk(
  "enquiry/submit",
  async ({ data, resetForm }, thunkAPI) => {

    try {
      thunkAPI.dispatch(showLoader())
      let fileUrls = [];

      if (data.files && data.files.length > 0) {
        const uploadResponse = await uploadFiles(data.files);
        fileUrls = uploadResponse.map((file) => file.path);
      }

      const payload = {
        fullName: data.fullName,
        email: data.email,
        phoneNumber: data.phoneNumber,
        serviceQuestion: data.serviceId,
        propertyType: data.propertyType,
        message: data.message,
        files: fileUrls,
      };

      const response = await api("post", endPoints.CREATE_ENQUIRE, payload);
      if (response.success) {
        thunkAPI.dispatch(
          showToast({ type: "success", message: response?.message })
        );
        resetForm && resetForm()
        thunkAPI.dispatch(hideLoader())
        return response.data;
      }
      thunkAPI.dispatch(hideLoader())
    } catch (error) {
      thunkAPI.dispatch(
        showToast({ type: "error", message: error?.message })
      );
      thunkAPI.dispatch(hideLoader())
    }

  }
);

const enquirySlice = createSlice({
  name: "enquiry",
  initialState: {
    loading: false,
    success: false,
    error: null,
    uploadedFiles: [],
  },
  reducers: {
    resetEnquiryState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    setUploadedFiles: (state, action) => {
      state.uploadedFiles = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitEnquiry.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitEnquiry.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.uploadedFiles = [];
        action.asyncDispatch(showToast({ type: "success", message: action.message }));

      })
      .addCase(submitEnquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        action.asyncDispatch(showToast({ type: "error", message: action.message }));
      });
  },
});

export const { resetEnquiryState, setUploadedFiles } = enquirySlice.actions;
export default enquirySlice.reducer;
